import { z } from 'zod';

export const CutawayASchema = z.object({
    type: z.literal('cutaway-a'),
    data: z.object({
        text: z.string().max(25),
    }),
});
export type CutawayA = z.infer<typeof CutawayASchema>;
